<template>
     <div class="container pt-5">
            <div class="row mt-5">
                <div class="col-md-6 offset-md-3 mt-5">
                    <loginPanel v-if="page === 'login'"  @loginPage="loginPage" @ChangePage="ChangePage" :error_login="error_login" @googleLogin="googleLogin"></loginPanel>
                   <registerPanel v-else-if="page === 'register'" @ChangePage="ChangePage" @register="register" :error_messages="error_register"></registerPanel>

                </div>
            </div>
        </div>
</template>

<script>
import loginPanel from '../components/login-panel.vue'
import registerPanel from '../components/register-panel.vue'
import { LoaderPlugin } from 'vue-google-login';
export default {
    name: "login-page",
    components: { loginPanel, registerPanel },
    props: ["error_register","error_login", "params", "onSuccess", "onFailure","logoutButton","renderParams","onCurrentUser"],
      data() {
    return {
        page: 'login',
        message: "hello world",
    }
}, 
methods: {
    ChangePage(val) {
        this.page = val
    },
    loginPage(data) {
        // console.log(data, '<<<<< ini di bapak');
        this.$emit('loginPage', data)
    },
    register(data){
        console.log(data, '<<<<< ini di bapak');
      this.$emit('register',data)
    },
    googleLogin(data){
        this.$emit('googleLogin', data);
    }
  }
}
</script>

<style scoped>

</style>

